import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import sweetalert from "sweetalert2";
import "./vee-validate";
import {
  ValidationProvider,
  ValidationObserver,
  Validator,
} from "vee-validate";
import mainmixins from "./mainmixins.js";
import { mask } from "vue-the-mask";
import VueLocalStorage from "vue-localstorage";
import Typography from "@/components/elements/Typography.vue";
import Btn from "@/components/elements/Button.vue";

Vue.use(VueLocalStorage);
Vue.directive("mask", mask);

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("Btn", Btn);
Vue.component("Typography", Typography);

Vue.prototype.$liff = window.liff;
Vue.prototype.$swal = sweetalert;

Vue.config.productionTip = false;
Vue.mixin(mainmixins);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
